import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import Adjustment from './Adjustment';
import Settings from './Settings';

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class ToolbarAdjustments extends Component{

  @observable trans = {  };

  constructor(props) {

    super(props);
    this.trans = this.props.dictionaryStorage.getCurrentLangDict;
  }

  render() {

    const t = this.t;

    return (
      <div className="ToolbarAdjustments">
        <h6 className="Toolbar-title"><span>{t('Adjustments')}</span></h6>
        <div className="Toolbar-body">
          {
            ( !Settings.getSettingsIsActiveImage )
            &&
            <div className="UniversalPrevent"></div>
          }
          <Adjustment
            dictionaryStorage={this.props.dictionaryStorage}
            show={['brightness','contrast','saturate','stackblur','opacity']}
            showReset={true}
            showIconWithText={true}
            inToolbar={true}
          />
      </div>
      </div>
    );

  }
}


